import SwiperCore, { Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

SwiperCore.use([Thumbs]);

export default function B() {
    const { useLang, useState, useRouter } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const LOCAL_SITES: string[] = ['za', 'kr'];
    const IMG_MAP: any = {
        us: '',
        kr: '_kr',
    };
    const cards: any = [
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747302016459/2_1.jpg`,
            imgMobile: `https://websiteoss.ecoflow.com/upload/image/1747300729226/2_1m.jpg`,
            title: t('secB_tab1_title'),
            desc: t('secB_tab1_desc'),
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747302024881/2_2.jpg`,
            imgMobile: `https://websiteoss.ecoflow.com/upload/image/1747301402759/2_2m.jpg`,
            title: t('secB_tab2_title'),
            desc: t('secB_tab2_desc'),
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747302028558/2-3.jpg`,
            imgMobile: `https://websiteoss.ecoflow.com/upload/image/1747301418912/2_3m.jpg`,
            title: t('secB_tab3_title'),
            desc: t('secB_tab3_desc'),
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1754363285055/Frame%201612690202.jpg`,
            imgMobile: `https://websiteoss.ecoflow.com/upload/image/1754363285051/m_img01.jpg`,
            title: t('secB_tab4_title'),
            desc: t('secB_tab4_desc'),
        },
    ];

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div id="vanlife-roadtrips-B" className={`vanlife-roadtrips-B ${css['vanlife-roadtrips-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secB_title')}</p>
                    <p className="desc">{t('secB_desc')}</p>
                </div>
                <div className="swiper-container">
                    <Swiper
                        className="swiper-box"
                        effect="fade"
                        modules={[Thumbs]}
                        pagination={true}
                        thumbs={{ swiper: thumbsSwiper }}
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        onSlideChange={(swiper) => setActive(swiper.activeIndex)}
                    >
                        {cards?.map((item: any, k: number) => (
                            <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                                <div className="item-img">
                                    <EFPicture src={item?.img} alt={item?.title} />
                                </div>
                                <div className="card-text">
                                    <p className="card-title">{item?.title}</p>
                                    <p className="card-desc">{item?.desc}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <Swiper className="swiper-thumb-box" spaceBetween={24} onSwiper={setThumbsSwiper} slidesPerView={'auto'} initialSlide={0}>
                        {cards?.map((item: any, k: number) => (
                            <SwiperSlide className={`swiper-thumb-item ${active === k ? 'active' : ''}`} key={k}>
                                <div className="item-thumb-img">
                                    <EFPicture src={item?.imgMobile} alt={item?.title} />
                                </div>
                                <div className="card-thumb-mask"></div>
                                <p className="card-thumb-title">{item?.title}</p>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="tabs-container">
                    <div className="tab-img">
                        <EFPicture src={cards[active]?.imgMobile} alt={cards[active]?.title} />
                    </div>
                    <div className="tabs-box">
                        <ul className="tabs-inner" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                            {cards?.map((card: any, k: number) => (
                                <li className={`tab-item ${active === k ? 'active' : ''}`} key={k} onClick={() => setActive(k)}>
                                    {card?.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <p className="tab-desc">{cards[active]?.desc}</p>
                </div>
            </div>
        </div>
    );
}
